<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Notes</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <div class="card">
    <div class="card-body">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor"
        [(ngModel)]="notes"
        [placeholder]="'Enter your notes here...'"
      ></ngx-editor>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-light" (click)="save()">Save</button>
</div>
